import LazyLoad from "vanilla-lazyload";
//import Masonry from "masonry-layout";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import zenscroll from "zenscroll";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const header = document.querySelector("header");
const footer = document.querySelector("footer .topBanner");
const overlay = document.getElementById("overlay");
const overlayInner = overlay.querySelector(".inner");
const overlayCloser = overlay.querySelector(".closer");

window.addEventListener("load", function () {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  // check for "button" class and create layered button element
  let btnClassEls = document.querySelectorAll(".btn");
  btnClassEls.forEach((btnClassEl) => {
    // get color from btn class
    let btnColor = "green";
    if (btnClassEl.classList.contains("purple")) {
      btnColor = "purple";
    }

    // wrap our element with necessary top/bottom elements
    let btnContainer = document.createElement("div");
    btnContainer.classList.add("btn_wrap");
    btnContainer.classList.add(btnColor);
    btnClassEl.parentNode.appendChild(btnContainer);
    btnContainer.appendChild(btnClassEl);

    let btnTop = document.createElement("div");
    btnTop.classList.add("top");
    btnClassEl.parentNode.appendChild(btnTop);
    btnTop.appendChild(btnClassEl);

    let spanTop = document.createElement("span");
    spanTop.classList.add("top_background");
    btnClassEl.parentNode.appendChild(spanTop);
    btnClassEl.parentNode.appendChild(spanTop.cloneNode(true));

    let btnBottom = document.createElement("div");
    btnBottom.classList.add("bottom");
    btnClassEl.parentNode.appendChild(btnBottom);

    let spanBottom = document.createElement("span");
    spanBottom.classList.add("bottom_background");
    spanBottom.classList.add(btnColor);
    btnBottom.parentNode.appendChild(spanBottom);

    btnBottom.appendChild(spanBottom);
    btnBottom.appendChild(spanBottom.cloneNode(true));
  });

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // animate the homepage team grid with random animations over images
  let homeTeamGridEl = document.querySelector(".home .grid-cropped");
  if (typeof homeTeamGridEl != "undefined" && homeTeamGridEl != null) {

    let gridCells = homeTeamGridEl.querySelectorAll(".cell");
    let cellCount = gridCells.length;

    function animateCell() {
      // get random number
      let randomNum = Math.floor(Math.random() * cellCount);
      gridCells[randomNum].classList.add("animate");
      setTimeout(function() {
        gridCells[randomNum].classList.remove("animate");
      }, 2000);
    }

    const anim = setInterval(animateCell, 300);

  }

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  //initialize lazyload - sitewide for image
  const lazyLoad = new LazyLoad({
    elements_selector: ".loadmeview",
    callback_enter: loadImage
  });

  //initialize lazyload - autoplay videos
  const lazyLoadAutoVideo = new LazyLoad({
    elements_selector: ".autovideo",
    threshold: 30,
    callback_enter: playAutoVideo,
    callback_exit: pauseAutoVideo
  });

  // update homepage pager dots based on sections in viewport
  const homeSections = document.querySelectorAll('.home .section');

  function handleIntersection(entries) {
    entries.map((entry) => {
      if (entry.isIntersecting) {
        let actionSection = entry.target;
        let activeId = actionSection.getAttribute("data-id");
        // remove active class from all pagers
        removeActivePager();
        let activePager = document.querySelector("#fp-nav ul li[data-id='"+activeId+"']");
        activePager.classList.add("active");
      }
    });
  }
  
  const observerOptions = {
    threshold: 0,
    rootMargin: "-10% 0% -10% 0%"
  }
  const observer = new IntersectionObserver(handleIntersection, observerOptions);
  
  homeSections.forEach(homeSection => observer.observe(homeSection));

  // pin the homepage grid-cropped


  let pinEl = document.querySelector(".homepage .section.grid-cropped");
  if (typeof pinEl != "undefined" && pinEl != null) {

    // pin
    gsap.to(pinEl, {
      scrollTrigger: {
        trigger: pinEl,
        start: "top top",
        end: "+="+ (innerHeight + 2),
        markers: false,
        pin: true
      },
    })


    // animate in text after the team grid

    let teamGridTextEl = pinEl.querySelector(".header");
    let teamHeadline1 = teamGridTextEl.querySelector("h1");
    let teamHeadline2 = teamGridTextEl.querySelector("h2");
    let teamHeadlineText = teamGridTextEl.querySelector("p");
    
    gsap.set(teamHeadline1, {opacity: 0, y: 50});
    gsap.set(teamHeadline2, {opacity: 0, y: 50});
    gsap.set(teamHeadlineText, {opacity: 0, y: 50});

    gsap.to(teamHeadline1, {
      scrollTrigger: {
        trigger: teamGridTextEl,
        start: "top center",
      },
      opacity: 1,
      y: 0,
    })

    gsap.to(teamHeadline2, {
      scrollTrigger: {
        trigger: teamGridTextEl,
        start: "top center",
      },
      opacity: 1,
      y: 0,
      delay: .25,
    })

    gsap.to(teamHeadlineText, {
      scrollTrigger: {
        trigger: teamGridTextEl,
        start: "top center",
      },
      opacity: 1,
      y: 0,
      delay: .5,
    })

  }


  // initialize masonry

  let masonGrids = document.querySelectorAll(".masongrid");
  masonGrids.forEach((masonGrid) => {
    //injecting bottom margin into masonry cell
    let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masonGrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masonGrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer"
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy"
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  });

  // When the user scrolls the page, execute headerAnimate
  let st = document.body.scrollTop || document.documentElement.scrollTop;
  window.onscroll = function () {
    if (body.classList.contains("homepage")) {
      st = document.body.scrollTop || document.documentElement.scrollTop;
      // check if user has scrolled 50% of window height
      if (st >= innerHeight / 3) {
        // show the header
        header.classList.add("show");
      } else {
        // hide the header
        header.classList.remove("show");
      }
    }
    if (body.classList.contains("header_bg")) {
      console.log("hello");
      st = document.body.scrollTop || document.documentElement.scrollTop;

      if (st >= innerHeight / 4) {
        // show the header
        header.classList.add("show");
      } else {
        // hide the header
        header.classList.remove("show");
      }
    }
  };

  function headerAnimate() {
    var winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    var height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    progressBar.style.width = scrolled + "%";
  }

  if (body.classList.contains("homepage")) {
    if (footer) {
      footer.classList.add("home");
    }
  }
  //initialize flickity for slideshows

  let slideshowEl = document.querySelector(".slideshow");
  let counterEl = document.querySelector(".counter .current");

  if (typeof slideshowEl != "undefined" && slideshowEl != null) {
    let flkty = new Flickity(slideshowEl, {
      // options
      fade: true,
      cellSelector: ".cell"
    });

    // change event
    flkty.on("change", function (index) {
      let slideCount = index + 1;
      counterEl.innerHTML = slideCount;
    });
  }

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  // CUSTOM VIDEO CONTROLS =========================
  function videoControls(player) {
    let video = player.querySelector("video");
    let controls = player.querySelector(".controls");
    //let largeBtn = player.querySelector(".largeBtn");
    let playpauseBtn = player.querySelector(".playpause");
    let muteBtn = player.querySelector(".mute");
    let volumeSlider = player.querySelector("#volume-bar");
    let volumeBg = player.querySelector(".volume .bg");
    let seekSlider = player.querySelector("#seek-bar");
    let seekBg = player.querySelector(".scrubber .bg");
    let fullBtn = player.querySelector(".gofull");
    let closeBtn = player.querySelector(".close-icon");
    let timestampEl = player.querySelector(".timestamp");
    let durationEl = player.querySelector(".timestamp .duration");
    let progressEl = player.querySelector(".timestamp .progress");

    // event listeners
    //video.addEventListener("canplay", videoCanPlay);
    video.addEventListener("playing", videoPlaying);
    video.addEventListener("pause", videoPaused);
    video.addEventListener("timeupdate", videoTimeUpdate);
    video.addEventListener("ended", videoEnded);
    //largeBtn.addEventListener("click", playPause);
    video.addEventListener("click", playPause);
    playpauseBtn.addEventListener("click", playPause);
    muteBtn.addEventListener("click", volumeToggle);
    seekSlider.addEventListener("input", videoSeek);
    //volumeSlider.addEventListener("input", volumeChange);
    fullBtn.addEventListener("click", goFullView);
    //closeBtn.addEventListener("click", closeFullView);

    // keyboard events
    body.addEventListener("keydown", (event) => {
      // toggle play / pause of video with spacebar

      // esc key closes lightbox
      if (event.keyCode === 27 && body.classList.contains("full")) {
        event.preventDefault();
        body.classList.remove("full");
      }
    });

    // show / hide controls based on mousemovement over video
    var mousetimeout;
    player.onmousemove = function () {
      clearTimeout(mousetimeout);
      controls.classList.remove("hide");
      mousetimeout = setTimeout(function () {
        // hide video controls if no mouse movement after 2 seconds
        controls.classList.add("hide");
      }, 2000);
    };

    player.onmouseleave = function () {
      controls.classList.add("hide");
    };

    // hide controls after 2 seconds is no user action is taken
    setTimeout(function () {
      controls.classList.add("hide");
    }, 2000);

    // functions
    function playPause() {
      if (!video.paused && !video.ended) {
        video.pause();
      } else {
        video.play();
      }
    }

    function toggleFullScreen() {
      if (
        !document.fullscreenElement &&
        !document.mozFullScreen &&
        !document.webkitIsFullScreen &&
        !document.msFullscreenElement
      ) {
        if (player.requestFullscreen) {
          player.requestFullscreen();
        } else if (player.mozRequestFullScreen) {
          player.mozRequestFullScreen();
        } else if (player.webkitRequestFullscreen) {
          player.webkitRequestFullscreen();
        } else if (player.msRequestFullscreen) {
          player.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }

    function videoEnded() {
      player.classList.add("ended");
    }

    function videoCanPlay() {
      var vid_duration = video.duration;
      let vid_minutes = 0;
      let vid_seconds = 0;

      vid_minutes = parseInt(vid_duration / 60);
      if (vid_minutes < 10) {
        vid_minutes = `${vid_minutes}`;
      }
      vid_seconds = parseInt(vid_duration) - vid_minutes * 60;
      if (vid_seconds < 10) {
        vid_seconds = `0${vid_seconds}`;
      }

      var vid_dur_output = `${vid_minutes}:${vid_seconds}`;

      durationEl.innerHTML = vid_dur_output;
    }

    function videoPlaying() {
      body.classList.add("hide_mark");
      player.classList.add("playing");
      player.classList.remove("ended");
      player.classList.remove("paused");
      timestampEl.classList.add("show");
    }

    function videoPaused() {
      player.classList.remove("playing");
      player.classList.add("paused");
      body.classList.remove("hide_mark");
    }

    function videoTimeUpdate() {
      let rawTime = video.currentTime;
      let minutes = 0;
      let seconds = 0;

      minutes = parseInt(rawTime / 60);
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      seconds = parseInt(rawTime) - minutes * 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      let output = `${minutes}:${seconds}`;
      progressEl.innerHTML = output;

      // Calculate the slider value
      var value = (100 / video.duration) * video.currentTime;

      // transition the timestamp el by animation left value
      timestampEl.style.left = value + "%";

      // Update the slider value and bg value
      seekSlider.value = value;
      seekBg.style.width = value + "%";
    }

    function videoSeek() {
      // Calculate the new time
      var time = video.duration * (seekSlider.value / 100);

      // Update the video time
      video.currentTime = time;
    }

    function volumeToggle() {
      if (video.muted == false) {
        video.muted = true;
        player.classList.add("muted");
      } else {
        video.muted = false;
        player.classList.remove("muted");
      }
    }

    function volumeChange() {
      video.volume = volumeSlider.value;
      volumeBg.style.width = volumeSlider.value * 100 + "%";
    }

    function goFullView() {
      toggleFullScreen();
    }

    function closeFullView() {
      body.classList.remove("full");
    }
  }

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      videoEl.play();
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = "/images/pics/1920/" + img;
      } else {
        imgpath = "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/500/" + img;
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function openOverlay() {
    overlay.classList.add("on");
    let videoCheck = overlayInner.querySelector("video");
    let videoWrapEl = overlayInner.querySelector(".media");
    if (typeof videoCheck != "undefined" && videoCheck != null) {
      videoControls(videoWrapEl);
      setTimeout(function() {
        videoWrapEl.classList.add("ready");
      }, 500);
    } else {
      let overlayImg = overlayInner.querySelector("img.photo");
      loadImage(overlayImg);
      setTimeout(function() {
        videoWrapEl.classList.add("ready");
      }, 500);
    }
  }

  function closeOverlay() {
    overlay.classList.remove("on");
    overlayInner.innerHTML = "";
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {
    // handle resizing of AR Rows
    let arRowsCell = document.querySelectorAll(".ar-rows .row .cell");
    for (let i = 0; i < arRowsCell.length; ++i) {
      var _this = arRowsCell[i],
        container = _this.closest(".ar-rows"),
        rowsMargin = container.getAttribute("data-margin"),
        percW = _this.getAttribute("data-percW"),
        percH = _this.getAttribute("data-percH"),
        ratio = _this.getAttribute("data-ratio"),
        num = _this.getAttribute("data-numImages"),
        containerWidth = container.offsetWidth - rowsMargin * (num - 1);

      _this.style.width = containerWidth * percW + "px";
      let cellImg = _this.querySelector("img");
      cellImg.style.height = ratio * (containerWidth * percW) + "px";
    }
  }

  window.addEventListener("resize", reportWindowSize);

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // logo hover animation
  let logoEl = header.querySelector(".logo");
  let logoTop = logoEl.querySelector(".half1");
  let logoBottom = logoEl.querySelector(".half2");
  
  logoEl.addEventListener("mouseenter", function() {
    gsap.to(logoTop, {
      x: "-100%",
      ease: "back.in(.5)",
      duration: .5,
      onComplete: function() {
        gsap.set(logoTop, {x: "100%"})
        gsap.to(logoTop, {
          x: 0,
          ease: "back.in(.5)",
          duration: .5,
        })
      }
    })
    gsap.to(logoBottom, {
      x: "100%",
      ease: "back.in(.5)",
      duration: .5,
      onComplete: function() {
        gsap.set(logoBottom, {x: "-100%"})
        gsap.to(logoBottom, {
          x: 0,
          ease: "back.in(.5)",
          duration: .5,
        })
      }
    })
  });

  // hover video cells
  let hoverVideoEls = document.querySelectorAll(".cell.hovervideo");
  hoverVideoEls.forEach(hoverVideoEl => {
    hoverVideoEl.addEventListener("mouseenter", function() {
      playAutoVideo(hoverVideoEl);
    });
    hoverVideoEl.addEventListener("mouseleave", function() {
      pauseAutoVideo(hoverVideoEl);
    });
  })

  // scroll down arrow
  let scrollDownEls = document.querySelectorAll(".down-arrow");
  scrollDownEls.forEach((scrollDownEl) => {
    scrollDownEl.addEventListener("click", function(e) {
      e.preventDefault();
      zenscroll.toY(innerHeight);
    });
  });

  // homepage section nav click events
  let pagerNavEls = document.querySelectorAll("#fp-nav li");

  function removeActivePager() {
    pagerNavEls.forEach((pagerNavEl) => {
      pagerNavEl.classList.remove("active");
    });
  }

  pagerNavEls.forEach((pagerNavEl) => {
    pagerNavEl.addEventListener("click", function (e) {
      e.preventDefault();
      removeActivePager();
      let sectionId = pagerNavEl.getAttribute("data-id");
      let targetSection = document.querySelector(
        ".section[data-id='" + sectionId + "']"
      );
      pagerNavEl.classList.add("active");
      zenscroll.to(targetSection);
    });
  });

  // overlay links
  let overlayLinks = document.querySelectorAll(".openOverlay");
  overlayLinks.forEach((overlayLink) => {
    overlayLink.addEventListener("click", function (e) {
      e.preventDefault();
      let id = overlayLink.getAttribute("data-id");
      getAjax("/getItem.php?id=" + id, function (data) {
        overlayInner.innerHTML = data;
        // check for sizeload video content
        let videoSizeEl = overlayInner.querySelector("video.sizeload");
        if (typeof videoSizeEl != "undefined" && videoSizeEl != null) {
          sizeloadVideo(videoSizeEl);
        }
        openOverlay();
      });
    });
  });

  //hamburger menu toggle
  menuBtn.addEventListener(
    "click",
    function (event) {
      event.preventDefault(), document.body.classList.toggle("menuOn");
    },
    true
  );

  // close overlay
  overlayCloser.addEventListener(
    "click",
    function (event) {
      event.preventDefault();
      closeOverlay();
    },
    true
  );

  // example link for AJAX request
  const ajaxLink = document.querySelector("a.ajax");
  if (typeof ajaxLink != "undefined" && ajaxLink != null) {
    ajaxLink.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        // caption slug for URL
        let linkSlug = this.getAttribute("data-slug");
        window.location.hash = linkSlug;

        // ajax call to get page text
        getAjax("/getTextpage.php?slug=" + linkSlug, function (data) {
          // load data into overlay
          overlayInner.innerHTML = data;
          overlay.classList.add("on");
          // return side nav to "off" state
          nav.classList.remove("open");
          // add blur class to body
          body.classList.add("blur");
        });
      },
      true
    );
  }
});
